import { Injectable, Type } from '@angular/core';
import {
  ApiResponse,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import { mapToModel } from '@kinet-open-network/client/shared/data-access/model';
import { BankPayment } from '../models/bank-payment.model';

@Injectable({
  providedIn: 'root',
})
export class BankPaymentsService extends BaseApiService<BankPayment> {
  override model: Type<BankPayment> = BankPayment;

  override get endpoint(): string {
    return '/invoicing/banks/payments';
  }

  sync(id: string) {
    return this.http
      .post<
        ApiResponse<BankPayment>
      >(`${this.endpoint}/${this.encodeId(id)}/sync`, {})
      .pipe(mapToModel(BankPayment, 'data'));
  }

  cancel(id: string) {
    return this.http
      .post<
        ApiResponse<BankPayment>
      >(`${this.endpoint}/${this.encodeId(id)}/cancel`, {})
      .pipe(mapToModel(BankPayment, 'data'));
  }
}
